import { useEffect, useState } from 'react';
import { maestroApiCall } from '@michelin/central-provider';
import { getVehicleLabel } from 'compositions/Wizard/SelectVehicle/VehicleSelection';
import { useCurrentLocationIsDealer } from 'hooks/useCurrentLocationIsDealer';
import { useQuery } from 'react-query';
import { apigatewayBaseRoute as baseURL } from 'services/restApiConst';
import { VehicleType } from 'types/UFOTypes';
import { useDebounce } from 'use-debounce/lib';

export const useGetVehicles = (fleetNumber: string) => {
  const [resultList, setResultList] = useState<VehicleType[]>([]);
  const [loading, setLoading] = useState(false);
  const isDealer = useCurrentLocationIsDealer();
  const [endpoint, setEndpoint] = useState(isDealer ? '' : `vehicles/${fleetNumber}?type=urban`);
  const [debouncedEndpoint] = useDebounce(endpoint, 500);

  const response = useQuery<{ data: VehicleType[] } | null>(
    ['useGetVehicles', debouncedEndpoint],
    () => {
      if (!debouncedEndpoint) return null;
      return maestroApiCall({
        method: 'GET',
        endpoint: debouncedEndpoint,
        baseURL,
      });
    },
    {
      cacheTime: 3600,
    },
  );

  useEffect(() => {
    if (response.data && Array.isArray(response.data?.data)) {
      setResultList(response.data.data);
      setLoading(false);
    }
  }, [response.data]);

  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (isDealer && event.target.value.length < 4) {
      setEndpoint('');
      setResultList([]);
      return;
    }
    const safeValue = event.target.value || '';
    setLoading(true);
    if (isDealer) {
      setEndpoint(`vehicles/${fleetNumber}?query=${safeValue}&dealerMode=true&type=urban`);
    } else setEndpoint(`vehicles/${fleetNumber}?query=${safeValue}&type=urban`);
  };

  return {
    list: resultList.map((v: VehicleType) => ({
      value: v.fleet_id_no,
      label: getVehicleLabel(v),
      data: v,
    })),
    onSearch,
    loading,
  };
};
